import React, {Component} from 'react';

import HeaderBrand from './HeaderBrand';
import HeaderUserControls from './HeaderUserControls';

class Header extends Component {
	constructor() {
		super();

		this.state = {
			"isActive": false
		}

		this.toggleNavbar = this.toggleNavbar.bind(this);
	}

	toggleNavbar(event) {
		this.setState({
			"isActive": !this.state.isActive
		});
	}

	render() {
		const { isActive } = this.state;
		return (
			<nav className="navbar has-shadow">
				<HeaderBrand isActive={isActive} onClick={this.toggleNavbar} />
				<div className={"navbar-menu " + (isActive ? "is-active" : "")}>
					<HeaderUserControls />
				</div>
			</nav>
		);
	}
}

export default Header;




// WEBPACK FOOTER //
// ./src/components/Header/Header.js